<script lang="ts">
import { computed, defineComponent } from 'vue';

import { wrapInArray } from '@components/utils';

import { CdsTransition, makeTransitionProps } from '../../composable';
import { CdsTransitionSlideY } from '../../transitions';

import type { PropType } from 'vue';

export const componentName = 'CdsInputMessages';
export default defineComponent({
  name: componentName,
  components: { CdsTransition },
  props: {
    active: Boolean as PropType<boolean>,
    error: Boolean as PropType<boolean>,
    messages: {
      type: [Array, String] as PropType<string | string[]>,
      default: () => []
    },

    ...makeTransitionProps({
      transition: {
        component: CdsTransitionSlideY,
        leaveAbsolute: true,
        group: true
      }
    })
  },
  setup(props) {
    const internalMessages = computed(() => wrapInArray(props.messages));
    const messagesClasses = computed(() => ({
      ['cds-input__messages--error']: props.error
    }));

    return {
      internalMessages,
      messagesClasses
    };
  }
});
</script>

<template>
  <cds-transition
    :transition="transition"
    tag="div"
    class="cds-input__messages"
    :class="[messagesClasses]"
    role="alert"
    aria-live="polite"
  >
    <template v-if="active || error">
      <span v-for="(message, i) of internalMessages" :key="`${i}-${message}`">
        {{ message }}
      </span>
      <span>
        <slot />
      </span>
    </template>
  </cds-transition>
</template>
